import { render, staticRenderFns } from "./ExpenditureCompensationRequestHistory.vue?vue&type=template&id=c6550044&scoped=true"
import script from "./ExpenditureCompensationRequestHistory.vue?vue&type=script&lang=js"
export * from "./ExpenditureCompensationRequestHistory.vue?vue&type=script&lang=js"
import style0 from "./ExpenditureCompensationRequestHistory.vue?vue&type=style&index=0&id=c6550044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6550044",
  null
  
)

export default component.exports